module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.image) ? _c('div', {
    staticClass: "dialog-wrap"
  }, [_c('b-dialog', {
    attrs: {
      "mask": _vm.dialogData.mask,
      "mshow": _vm.dialogData.show,
      "maskOpacity": _vm.dialogData.maskOpacity,
      "maskBackground": _vm.dialogData.maskBackground,
      "maskClass": _vm.maskClass
    }
  }, [_c('div', {
    staticClass: "pop-box"
  }, [_c('div', {
    staticClass: "pop-image",
    on: {
      "click": _vm.imageAction
    }
  }, [_c('beast-image', {
    attrs: {
      "image": _vm.image,
      "containerWidth": _vm.containerWidth
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "close-box",
    on: {
      "click": _vm.popClose
    }
  }, [_c('div', {
    staticClass: "close"
  })])])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4717f50a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/app-index-V4/components/pop.vue
// module id = 982
// module chunks = 13